var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RouteFiller } from "../helpers/Helpers";
import { CollaborationServiceSetup } from "../Setup";
export var AdjacentIdsController = {
    /*****************************************************************************************************
        * Is using route "api/adjacentIds/forContext/{context}" and http method "GET" to call the back-end.
    
        * @param {string} context
        * @returns {AdjacentIdsDownloadDto[]}
    ******************************************************************************************************/
    GetForContext: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/adjacentIds/forContext/{context}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/adjacentIds/single/{id}" and http method "GET" to call the back-end.
    
        * @param {string} id
        * @returns {ExtendedDataCollection<CategoryDownloadDto, AdjacentIdsDownloadDto>}
    ******************************************************************************************************/
    GetSingle: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/adjacentIds/single/{id}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/adjacentIds/{id}" and http method "PATCH" to call the back-end.
    
        * @param {string} id
        * @param {AdjacentIdsUploadDto} adjs
        * @returns {ExtendedDataCollection<CategoryDownloadDto, AdjacentIdsDownloadDto>}
    ******************************************************************************************************/
    Patch: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("adjs", JSON.stringify(data.adjs));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/adjacentIds/{id}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
};
/*
$PrintDebugInfo
*/ 
//# sourceMappingURL=AdjacentIdsController.js.map